/**
 * As palavras de Folha e gastos (F146, F186), lidas pelo site e pelo app do
 * celular (F310).
 */
/**
 * A situação de uma pessoa na folha do mês. `null` é "não há nada
 * cadastrado" — diferente de zero, que é "não há o que pagar".
 *
 * F186: "Pago a mais" era "Pago", em verde, ao lado de um "falta −R$ 500,00"
 * — e verde é a cor de "não precisa olhar". Precisa.
 */
export const payrollStatusText = (status) => {
    switch (status) {
        case 'paid':
            return { label: 'Pago', tone: 'success' };
        case 'partial':
            return { label: 'Parcial', tone: 'warning' };
        case 'pending':
            return { label: 'Pendente', tone: 'neutral' };
        case 'overpaid':
            return { label: 'Pago a mais', tone: 'danger' };
        case null:
            return { label: 'Sem salário', tone: 'neutral' };
    }
};
/** De onde saiu o dinheiro do lançamento. */
export const expenseSourceLabel = (entry) => (entry.paymentSource === 'cash' ? 'Caixa' : 'Pix/banco/outro');
//# sourceMappingURL=expenses.js.map